import axios from "../../utils/axios-util";

// Action types
const REQUEST_REGION_DATA = '[REGION] REQUEST';
const SET_REGION_DATA = '[REGION] SET';
const FAIL_REGION_DATA = '[REGION] FAIL';
const RESET_REGION_DATA = '[REGION] RESET';
const SET_SELECTED_REGIONS = '[REGION] SELECTED';
const SET_SELECTED_CIRCLES = '[CIRCLE] SELECTED';
const SET_SELECTED_CITIES = '[CITY] SELECTED';
const SET_SELECTED_SITES = '[SITES] SELECTED';
const RESET = '[REGION] RESET_FILTERS';
const SET_SELECTED_VENDOR = 'SET_SELECTED_VENDOR';
const SET_SELECTED_TECHNOLOGY = 'SET_SELECTED_TECHNOLOGY';
const SET_SELECTED_TEMPORAL = 'SET_SELECTED_TEMPORAL';
const SET_SELECTED_REGIONAL = 'SET_SELECTED_REGIONAL';

const REQUEST_CIRCLE_DATA = "[CIRCLE] REQUEST";
const SET_CIRCLE_DATA = "[CIRCLE] SET";
const FAIL_CIRCLE_DATA = "[CIRCLE] FAIL";

const REQUEST_CITY_DATA = "[CITY] REQUEST";
const SET_CITY_DATA = "[CITY] SET";
const FAIL_CITY_DATA = "[CITY] FAIL";

const REQUEST_SITE_DATA = "[SITE] REQUEST";
const SET_SITE_DATA = "[SITE] SET";
const FAIL_SITE_DATA = "[SITE] FAIL";


// Action Creators
//region
const requestRegionData = () => ({ type: REQUEST_REGION_DATA });
const setRegionData = (data) => ({ type: SET_REGION_DATA, payload: data });
const failedRegionData = (error) => ({ type: FAIL_REGION_DATA, payload: error });
//circle
const requestCircleData = () => ({ type: REQUEST_CIRCLE_DATA });
const setCircleData = (data) => ({ type: SET_CIRCLE_DATA, payload: data });
const failedCircleData = (error) => ({ type: FAIL_CIRCLE_DATA, payload: error });
//city
const requestCityData = () => ({ type: REQUEST_CITY_DATA });
const setCityData = (data) => ({ type: SET_CITY_DATA, payload: data });
const failedCityData = (error) => ({ type: FAIL_CITY_DATA, payload: error });
//Site
const requestSiteData = () => ({ type: REQUEST_SITE_DATA });
const setSiteData = (data) => ({ type: SET_SITE_DATA, payload: data });
const failedSiteData = (error) => ({ type: FAIL_SITE_DATA, payload: error });

export const resetRegionData = () => ({ type: RESET_REGION_DATA });
export const resetFilters = () => ({ type: RESET });

export const setSelectedRegionData = (data) => ({
  type: SET_SELECTED_REGIONS,
  payload: data
});

export const setSelectedCircleData = (data) => ({
  type: SET_SELECTED_CIRCLES,
  payload: data
});

export const setSelectedCityData = (data) => ({
  type: SET_SELECTED_CITIES,
  payload: data
});

export const setSelectedVendorData = (data) => ({
  type: SET_SELECTED_VENDOR,
  payload: data
});

export const setSelectedTechnologyData = (data) => ({
  type: SET_SELECTED_TECHNOLOGY,
  payload: data
});

export const setSelectedTemporalData = (data) => ({
  type: SET_SELECTED_TEMPORAL,
  payload: data
});

export const setSelectedRegionalData = (data) => ({
  type: SET_SELECTED_REGIONAL,
  payload: data
});

export const setSelectedSitesData = (data) => ({
  type: SET_SELECTED_SITES,
  payload: data
});

export const fetchRegionData = (customer) => (dispatch) => {
  dispatch(requestRegionData());

  const options = {
    method: 'GET',
    url: `infra/${customer}/regionsapi`
  };

  axios
    .request(options)
    .then((response) => {
      const data = response.data.map((regionName) => ({
      name: regionName,
    }));
      // const data = Object.entries(response.data).map(([regionName, circles]) => {
      //   return {
      //     name: regionName,
      //     circles: Object.entries(circles).map(([circleName, cities]) => ({
      //       name: circleName,
      //       cities: Object.entries(cities).map(([cityName, siteGroups]) => ({
      //         name: cityName,
      //         sites: siteGroups.flatMap(siteGroup => 
      //           siteGroup.sites.map(site => ({
      //             nodeId: site.nodeId,
      //             name: site.name
      //           }))
      //         )
      //       }))
      //     }))
      //   };
      // });

      // Dispatch the data to Redux
      dispatch(setRegionData(data));
    })
    .catch((error) => {
      dispatch(failedRegionData(error));

      let messageToShow = 'Unable to fetch data';
      if (error.response) {
        messageToShow = error.response.data.message;
      }
      console.error("Error fetching region data: ", messageToShow);
    });
};

export const fetchCircleData = (customer, request) => async (dispatch) => {
  dispatch(requestCircleData());

  try {
    const options = {
      method: "POST",
      url: `infra/${customer}/circlesapi`,
      data:  request ,
    };

    const response = await axios.request(options);
    const data = response.data.map((circleName) => ({
      name: circleName,
    }));
    await dispatch(setCircleData(data));
    return data;
  } catch (error) {
    console.error("Error fetching circle data:", error);
    await dispatch(failedCircleData(error));
    return [];
  }
};

export const fetchCityData = (customer, request) => async (dispatch) => {
  dispatch(requestCityData());

  try {
    const options = {
      method: "POST",
      url: `infra/${customer}/citysapi`,
      data: request ,
    };

    const response = await axios.request(options);
    const data = response.data.map((cityName) => ({
      name: cityName,
    }));
    await dispatch(setCityData(data));
    return data;
  } catch (error) {
    console.error("Error fetching city data:", error);
    await dispatch(failedCityData(error));
    return [];
  }
};

export const fetchSiteData = (customer, request) => async (dispatch) => {
  dispatch(requestSiteData());

  try {
    const options = {
      method: "POST",
      url: `infra/${customer}/sitesapi`,
      data: request ,
    };

    const response = await axios.request(options);
    const allSites = response?.data?.flatMap(group =>
    group.sites.map(site => ({
      nodeId: site.nodeId,
      name: site.name
    }))
  );
    await dispatch(setSiteData(allSites));
    return allSites;
  } catch (error) {
    console.error("Error fetching circle data:", error);
    await dispatch(failedCircleData(error));
    return [];
  }
};

// Initial State
const REGION_INITIAL_STATE = {
  regionData: null,
  circleData:[],
  cityData:[],
  siteData:[],
  selectedRegions: [],
  selectedCircles: [],
  selectedCities: [],
  selectedSites: [],
  selectedVendor: '',
  selectedTechnology: '',
  selectedTemporal: '',
  selectedRegional: '',
  loadingRegion: false,
  loadingCircle: false,
  loadingCity: false,
  loadingSite: false,
};

// Reducer
export default function regionReducer(state = REGION_INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_REGION_DATA:
      return { ...state, loading: true };
    case SET_REGION_DATA:
      return { ...state, loading: false, regionData: action.payload, selectedRegions: [] };
    case FAIL_REGION_DATA:
      return { ...state, loading: false, regionData: null, error: action.payload };
    case RESET_REGION_DATA:
      return { ...state, regionData: null, selectedRegions: [], selectedCircles: [], selectedCities: [], selectedSites: [] };
    case SET_SELECTED_REGIONS:
      return { ...state, selectedRegions: action.payload, selectedCircles: [], selectedCities: [], selectedSites: [] };
    case REQUEST_CIRCLE_DATA:
      return { ...state, loading: true, error: null };
    case SET_CIRCLE_DATA:
      return { ...state, loading: false, circleData: action.payload };
    case FAIL_CIRCLE_DATA:
      return { ...state, loading: false, error: action.payload };
    case SET_SELECTED_CIRCLES:
      return { ...state, selectedCircles: action.payload, selectedCities: [], selectedSites: [] };
    case SET_SELECTED_VENDOR:
      return { ...state, selectedVendor: action.payload }
    case SET_SELECTED_TECHNOLOGY:
      return { ...state, selectedTechnology: action.payload }
    case SET_SELECTED_TEMPORAL:
      return { ...state, selectedTemporal: action.payload }
    case SET_SELECTED_REGIONAL:
      return { ...state, selectedRegional: action.payload }
    case REQUEST_CITY_DATA:
      return { ...state, loading: true, error: null };
    case SET_CITY_DATA:
      return { ...state, loading: false, cityData: action.payload };
    case FAIL_CITY_DATA:
      return { ...state, loading: false, error: action.payload };
    case REQUEST_SITE_DATA:
      return { ...state, loading: true, error: null };
    case SET_SITE_DATA:
      return { ...state, loading: false, siteData: action.payload };
    case FAIL_SITE_DATA:
      return { ...state, loading: false, error: action.payload };
    case SET_SELECTED_CITIES:
      return { ...state, selectedCities: action.payload, selectedSites: [] };
    case SET_SELECTED_SITES:
      return { ...state, selectedSites: action.payload };
    case RESET:
      return { ...state, selectedRegions: [],
        selectedCircles: [],
        selectedCities: [],
        selectedSites: [],
        circleData:[],
        cityData:[],
        siteData:[],
        selectedTechnology: '',
        selectedVendor: '',
        selectedTemporal: '',
        selectedRegional: ''
      };
    default:
      return state;
  }
}
